import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DtoSecurityItem} from "./models/DtoSecurityItem";
import {SettingsSecurityService} from "./settings-security.service";
import {DialogService} from "@progress/kendo-angular-dialog";
import {SecurityAuthorisationComponent} from "./security-authorisation.component";
import {TreeViewComponent} from "@progress/kendo-angular-treeview";


@Component({
    selector: 'app-settings-security',
    template: require('./settings-security.component.html'),
    styles: [require('./settings-security.component.css')]
})

@AutoUnsubscribe()
export class SettingsSecurityComponent implements OnInit {
    @ViewChild('tvData', {static: false}) tvData: TreeViewComponent;
    filterHeaderConfig: PageHeaderBarConfig;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    selectedKeys: number[] = [];
    data: DtoSecurityItem[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'typeDescription',
            label: 'Onderdeel',
            type: 'string',
            width: '300px'
        },
        {
            key: 'employeeTypesDescription',
            label: 'Medewerkers toegestaan',
            type: 'string',
            width: '*'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private dialogService: DialogService,
                private ds: SettingsSecurityService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'instellingen', isLastStep: false },
            { text: 'beveiligingsinstellingen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'ONDERDELEN',
            buttonDefinition: [
                {
                    description: 'WIJZIGEN',
                    isSmall: false,
                    clickEventType: 'edit'
                }
            ]
        };

        this.ds.getSecurityBaseItems(true).subscribe();
    }

    ngAfterViewInit() {
        this.loadData(false);
    }

    loadData(reload: boolean) {
        if (reload || !this.data) {
            this.ds.getSecurityItems().subscribe((res: DtoSecurityItem[]) => {
                this.data = res;
            });
        }
    }

    phbBtnClicked(event) {
        if (event == 'edit' && this.selectedKeys[0]) {
            this.showAuthorisationEditWindow(this.selectedKeys[0]);
        }
    }

    itemDoubleClicked(event) {
        if (this.selectedKeys[0]) {
            this.showAuthorisationEditWindow(this.selectedKeys[0]);
        }
    }

    showAuthorisationEditWindow(type: number) {
        const dialogRef = this.dialogService.open({
            content: SecurityAuthorisationComponent
        });

        const dialogContent: SecurityAuthorisationComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.type = type;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadData(true);
                }
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-security/settings-security.component.ts